import React from "react";

import icon1 from "../assets/3d-printer.png";
import icon2 from "../assets/design.png";
import icon3 from "../assets/3d-object.png";
import icon4 from "../assets/web-development3.png";

export const featuresData = [
  {
    name: "Impresión 3D",
    description:
      "Desde prototipos innovadores hasta piezas funcionales y arte personalizado.",
    icon: <img src={icon1} alt="icono" width="60rem" />,
    imgClass: "one",
  },
  {
    name: "Diseño en general",
    description:
      "Carteles, banners, tarjetas de negocios, tarjetas de cumpleaños, entre otros.",
    icon: <img src={icon2} alt="icono" width="60rem" />,
    imgClass: "two",
  },
  {
    name: "Modelado 3D",
    description:
      "Modelado de piezas a medida, merchandising de tu marca y carteles luminosos.",
    icon: <img src={icon3} alt="icono" width="60rem" />,
    imgClass: "three",
  },
  {
    name: "Paginas web",
    description:
      "Sumar tu empresa al mundo digital nunca estuvo más al alcance.",
    icon: <img src={icon4} alt="icono" width="60rem" />,
    imgClass: "four",
  },
];
